import React, {useEffect, useState} from "react";
import HoaBasicForm from '../hoa-forms/hoa-basic-form';
import HoaAViolationRegulationsForm from '../hoa-forms/hoa-violation-regulations-form';

import datastore from '../../../store/hoa-datastore';
import DocumentsComponent from "../view/hoa-view-documents";
import HoaProcedureForm from "../hoa-forms/hoa-Procedure-form";
import HoaNewAemnitiesForm from "../hoa-forms/hoa-new-amenities-form";

const communityOptions = [
    'Snow Removal',
    "Animal Services",
    'Gardening',
    'Trash',
    "Recycling",
    'Telephone',
    'Internet',
    'Satellite Television/ Cable',
    'Landscaping'
]

export default function UpdateMainDashboard(props:any){

    const { tabIndex, selectedValues, hoa, newAvailableAmenities, setNewAvailableAmenities, accessInformation, setAccessInformation, amenityEvents, setAmenityEvents,previousHoa, updateHoaData, updateSelectedValues, setCurrentHoa, checkError, height, selectedMunicipality, view, error, setError, setDocumentWarning,checkNewAmenitiesWarning, checkDocumentWarning, emailValid, phoneValid, setEmailValid, setPhoneValid, setViolationRegulations, checkViolationWarning, goToSelectMunicipality, basicFormState, setBasicFormState, structureBuildingFiles, setStructureBuildingFiles, currentHoa, checkProcedureWarning, masterHoas, setMasterHoas, currentMasterHoa, setCurrentMasterHoa, sourceDocuments, setSourceDocuments, hoaEvents, setHoaEvents, onboardingDataState,previousOnboardingDataState, setOnboardingDataState, onboardingDocuments,setOnboardingDocuments, populateOnboardingDocuments} = props;

    const newAmenitiesStateList : any = {
        newAvailableAmenities:[],
        availableAmenitiesList:[],
        accessInformation:[],
        amenityEvents: []
    }

    const violationRegulationStateList: any = {
        minViolationFees: '',
        maxViolationFees: '',
        curePeriod: '',
        timeline: '',
        notificationType: '',
        preferredViolationRemediation: [],
        additionalInfoOfPortal: '',
        additionalInfoOfEmail: '',
        additionalInfoOfOther: '',
        violationPayment: '',
        gracePeriod: '',
        graceTimeline: '',
        assessmentFee: '',
        assessmentViolationFee: '',
        assessmentViolationFeeAdditionalInfo: '',
        assessmentFrequency: '',
        landscaping : {},
        trash: {},
        parking : {},
        nuisance: {},
        structure: {},
        others: ''
    }

    const [newAmenitiesState, setNewAmenitiesState] = useState(newAmenitiesStateList);
    const [violationRegulationState, setViolationRegulationState] = useState(violationRegulationStateList);
    const [availableCommunityServices, updateAvailableCommunityServices] = useState(communityOptions);

    // set basic form data
    useEffect(()=>{
        let tempState = {...basicFormState};
            Object.keys(tempState).map((key)=>{
                if(key === 'propertyManager'){
                    tempState[key] = selectedValues[key] || {}
                } else if(key === 'communityServices') {
                    tempState[key] = selectedValues[key] || [];
                    let existingService = [];
                    for(let service of  availableCommunityServices){
                        if(!tempState[key].includes(service)){
                            existingService.push(service)

                        }
                    }
                    updateAvailableCommunityServices(existingService)
                }else if(key === 'violationRegulations'){
                    tempState[key] = selectedValues[key] || {}
                }
                else if(key === 'hoaClientInfo'){
                    tempState[key] = selectedValues[key] || []
                }
                 else if(key === 'newAvailableAmenities'){
                    tempState[key] = selectedValues[key] || []
                }
                 else if(key === 'amenityEvents'){
                    tempState[key] = selectedValues[key] || []
                }
                 else if(key === 'accessInformation'){
                    tempState[key] = selectedValues[key] || []
                }
                else if(key === 'gateAccessFormFiles'){
                    tempState[key] = selectedValues[key] || []
                }
                else if(key === 'hoaEvents') {
                    //Need to changes for all array values. Its automatically changes selectedValues Data
                    const copyOfSelectedValues = JSON.parse(JSON.stringify(selectedValues));
                    tempState[key] = copyOfSelectedValues[key] || []
                }
                else {
                    tempState[key] = selectedValues[key];
                }
            })
            if(props.selectedMunicipality && props.selectedMunicipality.market){
                if(tempState.municipality !== props.selectedMunicipality){
                    tempState.municipality = props.selectedMunicipality;
                }
                if(tempState.market !== props.selectedMunicipality.market){
                    tempState.market = props.selectedMunicipality.market;
                }
                if(tempState.city !== props.selectedMunicipality.city){
                    tempState.city = props.selectedMunicipality.city;
                }
            }
            if(props.selectedValues && props.selectedValues?.newAvailableAmenities){
                tempState.newAvailableAmenities = props.selectedValues.newAvailableAmenities;
            }
            if(props.selectedValues && props.selectedValues?.amenityEvents){
                tempState.amenityEvents = props.selectedValues.amenityEvents;
            }
            if(props.selectedValues && props.selectedValues?.accessInformation){
                tempState.accessInformation = props.selectedValues.accessInformation;
            }
            if(props.selectedValues && props.selectedValues.documents){
                tempState.documents = props.selectedValues.documents;
            }
            if(props.selectedValues && props.selectedValues.procedures){
                tempState.procedures = props.selectedValues.procedures;
            }
            tempState.selectedCommunityService = '';
            setBasicFormState(tempState);
            setCurrentHoa(tempState);
    }, []);

    // set amenities form data
    useEffect(()=>{
        if(view === "update" && selectedValues){
            let newTempState = {...newAmenitiesState};
            Object.keys(newTempState).map((key)=>{
                newTempState[key] = selectedValues[key] || (Array.isArray(newTempState[key]) ? [] : typeof newTempState[key] === 'object' ? {} : '');
            })
            setNewAmenitiesState(newTempState)
        }

        // return () => {
        //     setAmenityEvents(selectedValues.amenityEvents);
        //     setAccessInformation(selectedValues.accessInformation);
        //     setNewAvailableAmenities(selectedValues.newAvailableAmenities);
        // }
    }, []);

    // set violation regulation form data
    useEffect(() => {
        if (view === "update" && selectedValues && selectedValues.violationRegulations) {
            const selectedValuesViolationRegulations = JSON.parse(JSON.stringify(selectedValues.violationRegulations));

            let tempState = { ...violationRegulationState };
            Object.keys(tempState).map((key) => {
                tempState[key] = selectedValuesViolationRegulations[key] || (Array.isArray(tempState[key]) ? [] : typeof tempState[key] === 'object' ? {} : '');
            })
            if(!Array.isArray(selectedValues?.violationRegulations?.preferredViolationRemediation)){
                tempState.preferredViolationRemediation = [];
            }
            setViolationRegulationState(tempState);
        }
        // return () => {
        //     setViolationRegulations(selectedValues.violationRegulations);
        // }
    }, []);

    if(tabIndex === 0)
        return <HoaBasicForm state={basicFormState} setState={setBasicFormState} setCurrentHoa = {setCurrentHoa} checkError={checkError} height={window.innerHeight - datastore.responsiveHeightWithtab} selectedMunicipality = {selectedMunicipality} view={view} selectedValues={selectedValues} error={error} setError={setError} emailValid={emailValid} phoneValid={phoneValid} setEmailValid={setEmailValid} setPhoneValid = {setPhoneValid} masterHoas={masterHoas} setMasterHoas={setMasterHoas} currentMasterHoa={currentMasterHoa} setCurrentMasterHoa={setCurrentMasterHoa} updateHoaData={updateHoaData} updateSelectedValues={updateSelectedValues} hoaEvents={hoaEvents} setHoaEvents={setHoaEvents} hoa={hoa} previousHoa={previousHoa}  onboardingDataState={onboardingDataState} previousOnboardingDataState={previousOnboardingDataState} setOnboardingDataState={setOnboardingDataState} onboardingDocuments={onboardingDocuments} setOnboardingDocuments={setOnboardingDocuments} populateOnboardingDocuments={populateOnboardingDocuments} />
    else if(tabIndex === 1)
        return <HoaProcedureForm setBasicFormState={setBasicFormState} currentHoa={currentHoa} setCurrentHoa={setCurrentHoa} checkProcedureWarning={checkProcedureWarning} sourceDocuments={sourceDocuments} setSourceDocuments={setSourceDocuments} view={view}/>
    else if(tabIndex === 2)
        return <HoaNewAemnitiesForm state={newAmenitiesState} setState={setNewAmenitiesState} hoa={hoa} previousHoa={previousHoa} setCurrentHoa = {setCurrentHoa} updateHoaData={updateHoaData} updateSelectedValues={updateSelectedValues} newAvailableAmenities={newAvailableAmenities} setNewAvailableAmenities={setNewAvailableAmenities} amenityEvents={amenityEvents} setAmenityEvents={setAmenityEvents} accessInformation={accessInformation} setAccessInformation={setAccessInformation} checkNewAmenitiesWarning={checkNewAmenitiesWarning} height={window.innerHeight - datastore.responsiveHeightWithtab} selectedMunicipality = {selectedMunicipality} view={view} selectedValues={selectedValues} />
    else if(tabIndex === 3)
        return <HoaAViolationRegulationsForm state={violationRegulationState} setState={setViolationRegulationState} setViolationRegulations = {setViolationRegulations} height={window.innerHeight - datastore.responsiveHeightWithtab} selectedMunicipality = {selectedMunicipality} view={view} selectedValues={selectedValues} checkViolationWarning={checkViolationWarning} structureBuildingFiles={structureBuildingFiles} setStructureBuildingFiles={setStructureBuildingFiles}/>
    else 
        return <DocumentsComponent currentHoa={currentHoa} setCurrentHoa={setCurrentHoa} view={view} hoa={hoa} previousHoa={previousHoa} updateSelectedValues={updateSelectedValues} documents={selectedValues.documents} selectedValues={selectedValues} updateHoaData={updateHoaData} setDocumentWarning={setDocumentWarning} checkDocumentWarning={checkDocumentWarning} style={{height:height, overflowY:"auto"}} />
}